module.exports = __webpack_public_path__ + "img/linkedin-icon.c950eafd.svg";